import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

const cardColors = {
  unizar: 'bg-sky-600',
  precepta: 'bg-emerald-600',
  loadexpress: 'bg-amber-600',
  frqncy: 'bg-violet-600',
  kasa: 'bg-red-600',
  arqplus: 'bg-zinc-700',
  shipxchange: 'bg-cyan-600',
  cravyn: 'bg-orange-600'
};

export const CompanyCard = ({ company, index, onClick }) => {
  return (
    <motion.article
      initial={{ y: 40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ 
        delay: 0.1 + index * 0.1, 
        duration: 0.6, 
        ease: [0.22, 1, 0.36, 1] 
      }}
      onClick={() => onClick(company.id)}
      className={`company-card relative h-[280px] sm:h-[320px] lg:h-[380px] w-full overflow-hidden rounded-lg cursor-pointer group ${cardColors[company.id]} card-shadow`}
      data-testid={`company-card-${company.id}`}
    >
      {/* Logo - top on mobile, centered on desktop */}
      {company.logo && (
        <div className="absolute inset-x-0 top-4 md:top-0 md:bottom-0 flex items-start md:items-center justify-center pointer-events-none">
          <img 
            src={company.logo} 
            alt={`${company.name} logo`}
            className={`object-contain opacity-90 ${company.id === 'arqplus' ? 'w-24 h-24 md:w-32 md:h-32' : 'w-14 h-14 md:w-24 md:h-24'}`}
          />
        </div>
      )}

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end p-6">
        {/* Category Label */}
        <span className="text-xs font-mono uppercase tracking-[0.2em] text-white/70 mb-2">
          {company.category}
        </span>

        {/* Company Name */}
        <h3 className="text-2xl font-semibold tracking-tight text-white mb-2 flex items-center gap-2">
          {company.name}
          <ArrowUpRight className="w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity text-white" />
        </h3>

        {/* Tagline */}
        <p className="text-white/80 text-sm font-light leading-relaxed mb-4">
          {company.tagline}
        </p>

        {/* Website */}
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-white/60" />
          <span className="text-xs font-mono text-white/60">{company.website}</span>
        </div>
      </div>
    </motion.article>
  );
};
